import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Store, FileSpreadsheet, GraduationCap, BookOpen, Package } from "lucide-react";

interface CategoryFilterProps {
  categories: string[];
  selectedCategory: string;
  onSelectCategory: (category: string) => void;
  productCounts: Record<string, number>;
}

const categoryIcons: Record<string, React.ReactNode> = {
  loja: <Store className="h-4 w-4" />,
  planilha: <FileSpreadsheet className="h-4 w-4" />,
  curso: <GraduationCap className="h-4 w-4" />,
  ebook: <BookOpen className="h-4 w-4" />,
  ferramenta: <Package className="h-4 w-4" />,
};

export const CategoryFilter = ({
  categories,
  selectedCategory,
  onSelectCategory,
  productCounts,
}: CategoryFilterProps) => {
  const allCount = Object.values(productCounts).reduce((a, b) => a + b, 0);

  return (
    <div className="flex flex-wrap gap-3 justify-center">
      <Button
        variant={selectedCategory === "all" ? "default" : "outline"}
        onClick={() => onSelectCategory("all")}
        className="gap-2"
      >
        <Package className="h-4 w-4" />
        Todos
        <Badge variant="secondary" className="ml-1">
          {allCount}
        </Badge>
      </Button>

      {categories.map((category) => (
        <Button
          key={category}
          variant={selectedCategory === category ? "default" : "outline"}
          onClick={() => onSelectCategory(category)}
          className="gap-2"
        >
          {categoryIcons[category] || <Package className="h-4 w-4" />}
          {category.charAt(0).toUpperCase() + category.slice(1)}
          <Badge variant="secondary" className="ml-1">
            {productCounts[category] || 0}
          </Badge>
        </Button>
      ))}
    </div>
  );
};
